function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M79.576,29.366L69.411,19.202L24.606,64.007l-0.975,11.14l4.695-0.411l0.024,0.024l0.028-0.028l6.393-0.56L79.576,29.366z  M76.748,29.366l-2.917,2.917l-7.336-7.336l2.917-2.917L76.748,29.366z M29.902,61.54l32.969-32.969l1.149,1.149L31.051,62.689 L29.902,61.54z M65.434,31.134l2.563,2.563L35.028,66.666l-2.563-2.563L65.434,31.134z M69.411,35.112l0.795,0.795L37.238,68.876 l-0.795-0.795L69.411,35.112z M64.285,27.157l0.796-0.795l7.336,7.336l-0.795,0.795L64.285,27.157z M25.831,72.947l0.057-0.649 l0.592,0.592L25.831,72.947z M29.081,72.662l-2.965-2.965l0.42-4.791l1.952-1.952l7.336,7.336l-1.952,1.952L29.081,72.662z"
});

var SvgEdit = function SvgEdit(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "40px",
    viewBox: "0 0 100 100",
    style: {
      marginBottom: "-15px"
    },
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEdit, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/edit.8207300a.svg";
export { ForwardRef as ReactComponent };